import { useEffect, useState } from "react";

const EVENT_ISO = "2026-09-06T10:00:00+02:00";

export const CountdownChip = () => {
  const [diff, setDiff] = useState(() => Math.max(0, new Date(EVENT_ISO).getTime() - Date.now()));

  useEffect(() => {
    const id = setInterval(() => {
      setDiff(Math.max(0, new Date(EVENT_ISO).getTime() - Date.now()));
    }, 1000);
    return () => clearInterval(id);
  }, []);

  if (diff <= 0) return null;

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  const cell = (val, label, tid) => (
    <div className="flex flex-col items-center" data-testid={tid}>
      <div className="font-display font-black text-2xl md:text-3xl gold-text leading-none tabular-nums">
        {String(val).padStart(2, "0")}
      </div>
      <div className="eyebrow text-zinc-500 text-[9px] mt-1">{label}</div>
    </div>
  );

  return (
    <div
      data-testid="countdown"
      className="inline-flex items-center gap-3 md:gap-5 bg-black/40 backdrop-blur border border-[#FFCC51]/30 rounded-xl px-4 py-2.5"
    >
      <span className="eyebrow text-[#FFCC51] hidden md:block">Noch</span>
      {cell(days, "Tage", "countdown-days")}
      <span className="text-zinc-600">·</span>
      {cell(hours, "Std", "countdown-hours")}
      <span className="text-zinc-600">·</span>
      {cell(minutes, "Min", "countdown-minutes")}
      <span className="text-zinc-600 hidden md:inline">·</span>
      <span className="hidden md:block">
        {cell(seconds, "Sek", "countdown-seconds")}
      </span>
    </div>
  );
};
